// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1FTR6","list":"BalanceDue_list__3UFif","listRow":"BalanceDue_listRow__1mk02","total":"BalanceDue_total__1VYSf"};